import { render, staticRenderFns } from "./CreditsPanel.vue?vue&type=template&id=c6994610&scoped=true"
import script from "./CreditsPanel.vue?vue&type=script&lang=js"
export * from "./CreditsPanel.vue?vue&type=script&lang=js"
import style0 from "./CreditsPanel.vue?vue&type=style&index=0&id=c6994610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6994610",
  null
  
)

export default component.exports